import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    regionProvinceChannel = new Subject();
    regionCityChannel = new Subject();
    detailChannel = new Subject();
    updateChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
    }

    fetchRegionProvince = async (query) => {
        this.regionProvinceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionProvince(query).then((result) => {
            this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionCity = async (query) => {
        this.regionCityChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCity(query).then((result) => {
            this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUpdate(query).then((result) => {
            this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.updateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default UpdateBloc